module.exports = __webpack_public_path__ + "img/location_icon.661f9d0e.png";